"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.hasChangedForm = exports.addressValidator = exports.profileFormValidator = void 0;
const validators_1 = require("../../utils/validators");
const pick_1 = __importDefault(require("lodash/pick"));
const cloneDeep_1 = __importDefault(require("lodash/cloneDeep"));
const isEqual_1 = __importDefault(require("lodash/isEqual"));
const editable = [
    'additional_phone',
    'attorneys_range',
    'bio',
    'contact_person',
    'email',
    'firm_name',
    'street',
    'city',
    'state_id',
    'zip_code',
    'state_abbrev',
    'name',
    'website'
];
// validate profile form fields
const profileFormValidator = (validationFields, data) => {
    switch (data.field) {
        case 'firm_name':
            validationFields.firmNameValid = !!data.value;
            break;
        case 'email':
            validationFields.emailValid = data.value ? validators_1.validateEmail(data.value) : true;
            break;
        case 'name':
            validationFields.nameValid = !!data.value && validators_1.validateFullName(data.value);
            break;
        case 'contact_person':
            validationFields.contactPersonValid = !!data.value && validators_1.validateLength(data.value, 14);
            break;
        case 'additional_phone':
            validationFields.additionalPhoneValid = data.value && validators_1.validateLength(data.value, 14);
            break;
        case 'website':
            validationFields.websiteValid = data.value && validators_1.validateUrl(data.value);
            break;
        case 'zip_code':
            validationFields.zipCodeValid = data.value && validators_1.validateLength(data.value, 5);
    }
    return validationFields;
};
exports.profileFormValidator = profileFormValidator;
// validate address fields by given array properties
const addressValidator = (data) => {
    const addressGroup = ['street', 'city', 'zip_code'];
    const fields = pick_1.default(data, addressGroup);
    let filledData = 0;
    for (let key in fields) {
        if (!fields[key]) {
            filledData--;
        }
        else {
            filledData++;
        }
    }
    return filledData === addressGroup.length || filledData === -addressGroup.length;
};
exports.addressValidator = addressValidator;
// check if form has changed
const hasChangedForm = (form, user) => {
    const newForm = cloneDeep_1.default(form);
    newForm.website = newForm.website || null;
    return !isEqual_1.default(pick_1.default(newForm, editable), pick_1.default(user, editable));
};
exports.hasChangedForm = hasChangedForm;
